export { default } from "ember-stereo/-private/utils/evented";
